import { Sprite } from 'pixi.js';

import { Shared } from '../../App';
import { NineSliceButton } from './NineSliceButton';

const defaultOpts = {
    icon: 'icon-close',
    bg: 'yellow' as 'yellow' | 'magenta',
    startHidden: false,
};

export type SquareButtonOpts = typeof defaultOpts;

export class SquareButton extends NineSliceButton
{
    constructor(opts: Partial<SquareButtonOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };
        const icon = Sprite.from(Shared.assets.getTexture(o.icon));

        super({
            icon,
            bgAsset: `button-ninesliced-${o.bg}`,
            w: 120,
            h: 120,
            startHidden: o.startHidden,
        });
    }
}
